import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Input, signal } from '@angular/core';

@Component({
  selector: 'app-app-toggle-accordion',
  standalone: false,
  exportAs: 'rowAcc',
  templateUrl: './app-toggle-accordion.component.html',
  animations: [
    trigger('expandCollapse', [
      state('open', style({ height: '*', opacity: 1, paddingTop: '12px', paddingBottom: '12px' })),
      state('closed', style({ height: '0px', opacity: 0, paddingTop: '0', paddingBottom: '0', overflow: 'hidden' })),
      transition('open <=> closed', animate('220ms ease-in-out')),
    ]),
  ],
  styleUrl: './app-toggle-accordion.component.scss',
})
export class AppToggleAccordionComponent {
  @Input() openInitially = false;
  isOpen = signal(this.openInitially);
  toggle() { this.isOpen.update(v => !v); }
  open()   { this.isOpen.set(true); }
  close()  { this.isOpen.set(false); }
}
